import React, { forwardRef } from 'react';

import { Grid } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  content: {
    backgroundColor: theme.appColors.background,
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(1),
  },
}));

export const ContentWrapper = forwardRef(function ContentWrapper(
  { children, className }: React.HTMLAttributes<HTMLElement>,
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const { classes } = useStyles();

  return (
    <Grid
      ref={ref}
      container
      className={clsx(classes.content, className)}
      sx={{ flexDirection: 'column' }}
      wrap="nowrap"
    >
      {children}
    </Grid>
  );
});
